import React from "react";
import PropTypes from "prop-types";
import TextBlock from "../text/TextBlock";

const getQueryParameter = url => {
  const params = {};
  const parser = document.createElement("a");

  parser.href = url;

  const query = parser.search.substring(1);
  const vars = query.split("&");

  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split("=");
    params[pair[0]] = decodeURIComponent(pair[1]);
  }

  return params;
};

const getVideoCode = url => {
  const params = getQueryParameter(url);

  if (params.hasOwnProperty("v")) {
    return params["v"];
  }

  return "";
};

/**
 * VideoBlock: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * YouTube video block renderer
 *
 * @param {*} props
 */
const VideoBlock = props => (
  <div>
    {props.isReadOnlyMode ? (
      <iframe
        width="100%"
        height="515"
        src={`https://www.youtube-nocookie.com/embed/${getVideoCode(
          props.block.url
        )}`}
        title="Embedded YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    ) : (
      <TextBlock
        {...props}
        placeholder={"manuscript.blocks.video.placeholder"}
        dataKey={"url"}
      />
    )}
  </div>
);

VideoBlock.propTypes = {
  /**
   * block: {url}
   * Contains the content block information
   */
  block: PropTypes.shape({
    url: PropTypes.string
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired
};

export default VideoBlock;



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/media/VideoBlock.js